var Backbone = require('backbone'),
    fvChannel = require('glRadio').channel('FV');

/*
* Backbone Model representing the unauthorizedData endpoint.
* Contains data needed for login, prior to user authorization.
* */


module.exports = Backbone.Model.extend({

    defaults: {
        databases: [],
        signupUrl: null,
        forgotPasswordUrl: null
    },

    url: function() {
        return fvChannel.request('apiUrl').unauthorizedData;
    },

    getDatabases: function() {
        return this.get('databases');
    },

    getSignupUrl: function() {
        return this.get('signupUrl');
    },

    getForgotPasswordUrl: function() {
        return this.get('forgotPasswordUrl');
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/unauthorizedData.js
 ** module id = 761
 ** module chunks = 0
 **/